<!--开关设置-->
<template>
  <div>
    <el-row>
      <el-col :span="12" style="border-right: 1px solid #e5e5e5; padding: 10px;">
        <el-row><div class="row-title" style="background: #5872E0;">基础设置</div></el-row>
        <el-row style="margin-top: 20px;">
          <el-switch v-model="value1" @change="change1" inactive-text="在线支付"></el-switch>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-switch v-model="value2" @change="change2" inactive-text="app拍照"></el-switch>
        </el-row>
        <el-row style="margin-top: 20px;">
          <label>报抽单次结算金额：</label>
          <el-input v-model="form.pmCode" style="width: 80px;"></el-input>
        </el-row>
        <el-row style="margin-top: 40px;">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-row>
      </el-col>
      <el-col :span="12" style="padding: 10px;">
        <el-row><div class="row-title" style="background: #6CAC9D;">门户设置</div></el-row>
        <el-row style="margin-top: 20px;">
          <label>排行类型：</label>
          <el-select v-model="form1.lx" placeholder="请选择">
            <el-option label="报抽排行" value="0"></el-option>
            <el-option label="报修排行" value="1"></el-option>
          </el-select>
        </el-row>
        <el-row style="margin-top: 20px;">
          <label>排行周期：</label>
          <el-select v-model="form1.pmCode" placeholder="请选择">
            <el-option label="累计次数" value="1"></el-option>
            <el-option label="本日" value="2"></el-option>
            <el-option label="本周" value="3"></el-option>
            <el-option label="本月" value="4"></el-option>
            <el-option label="本季度" value="5"></el-option>
            <el-option label="本年度" value="6"></el-option>
          </el-select>
        </el-row>
        <el-row style="margin-top: 40px;">
          <el-button type="primary" @click="onSubmitRight">保存</el-button>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
    export default {
        name: 'SetSwitch',
        data () {
            return {
                value1: false,
                value2: false,
                form: {
                    code: 1,
                    parentCode: 12,
                    pmCode: ''
                },
                form1: {
                    uuid: '',
                    lx: '0',
                    pmCode: '1'
                }
            }
        },
        components: {
        },
        mounted () {
            this.getData()
            this.getDataRight()
        },
        methods: {
            getData: function () {
                let _this = this
                let param = {
                    baseService: 'TSysZdServiceImpl',
                    type: _this.GLOBAL.config.handleType.kgpzInfo
                }
                _this.loading = false
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData.code === '200') {
                            _this.form = resultData.obj
                            _this.setPageData()
                        } else {
                            _this.$message.warning('获取基础设置数据失败～')
                        }
                    }
                )
            },
            getDataRight: function () {
                let _this = this
                let param = {
                    baseService: 'TSysZdServiceImpl',
                    type: _this.GLOBAL.config.handleType.gzphInfo
                }
                _this.loading = false
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData.code === '200') {
                            _this.$message.success('获取数据成功～')
                            _this.form1 = resultData.obj
                        } else {
                            _this.$message.warning('获取门户设置数据失败～')
                        }
                    }
                )
            },
            setPageData: function () {
                if (this.form.code === '0') {
                    this.value1 = true
                } else {
                    this.value1 = false
                }
                if (this.form.parentCode === '11') {
                    this.value2 = true
                } else {
                    this.value2 = false
                }
            },
            change1: function (val) {
                if (val) {
                    this.form.code = 0
                } else {
                    this.form.code = 1
                }
            },
            change2: function (val) {
                if (val) {
                    this.form.parentCode = 11
                } else {
                    this.form.parentCode = 12
                }
            },
            onSubmit: function () {
                console.log('保存')
                let _this = this
                let param = {
                    baseService: 'TSysZdServiceImpl',
                    type: _this.GLOBAL.config.handleType.updateAll,
                    info: {
                        uuid: _this.form.uuid,
                        code: _this.form.code,
                        parentCode: _this.form.parentCode,
                        pmCode: _this.form.pmCode
                    }
                }
                _this.loading = false
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData.code === '200') {
                            _this.$message.success('保存设置成功～')
                        } else {
                            _this.$message.warning('保存设置失败～')
                        }
                    }
                )
            },
            // 门户设置保存
            onSubmitRight: function () {
                console.log('保存right')
                let _this = this
                let param = {
                    baseService: 'TSysZdServiceImpl',
                    type: _this.GLOBAL.config.handleType.updateAll,
                    info: {
                        uuid: _this.form1.uuid,
                        lx: _this.form1.lx,
                        pmCode: _this.form1.pmCode
                    }
                }
                _this.loading = false
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData.code === '200') {
                            _this.$message.success('保存设置成功～')
                        } else {
                            _this.$message.warning('保存设置失败～')
                        }
                    }
                )
            }
        }
    }
</script>
<style scoped>
  .row-title{
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/view/setFunction/SetSwitch.vue